module.exports = {
    buttonsClass: 'col-sm-offset-2 col-sm-10 btn-group',
    buttonClass: 'btn',
    formGroup: "form-group"
}


/** WEBPACK FOOTER **
 ** ./src/styles/ButtonsTemplate-style.js
 **/